"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const notifications_service_1 = require("./notifications.service");
const notification_log_entity_1 = require("./notification-log.entity");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
/**
 * Auth-protected notification endpoints.
 * Provider webhook callbacks live in WebhooksModule (/api/webhooks/*).
 */
let NotificationsController = class NotificationsController {
    constructor(notificationsService) {
        this.notificationsService = notificationsService;
    }
    // ── Log viewer ─────────────────────────────────────────────────────────────
    /**
     * GET /api/notifications
     * Paginated audit log of all outbound messages with customer + sentBy relations.
     * Supports: channel, status, template, search (name/phone/email), page, limit.
     */
    getLogs(channel, status, template, search, page, limit) {
        return this.notificationsService.findLogs({ channel, status, template, search, page, limit });
    }
    // ── Test send ──────────────────────────────────────────────────────────────
    /**
     * POST /api/notifications/test-send
     * Sends a minimal test message on the requested channels to verify provider
     * credentials are working.  Bypasses rate limiting and templates.
     *
     * Body: { channels: ['sms'|'whatsapp'|'email'], to: { phone?, email?, name? } }
     */
    testSend(body, user) {
        const channels = (body.channels ?? [])
            .map(ch => ch.toLowerCase())
            .filter((ch) => Object.values(notification_log_entity_1.NotificationChannel).includes(ch));
        return this.notificationsService.testSend(channels, body.to ?? {}, user.id);
    }
    sendPaymentRequest(body, user) {
        const channels = (body.channels ?? [])
            .map(ch => ch.toLowerCase())
            .filter((ch) => Object.values(notification_log_entity_1.NotificationChannel).includes(ch));
        return this.notificationsService.send({
            channels,
            to: body.to ?? {},
            template: notification_log_entity_1.NotificationTemplate.PAYMENT_DETAILS,
            variables: {
                customerName: body.to?.name ?? 'Customer',
                amount: body.amount,
                upiId: body.upiId,
            },
            referenceId: body.to?.customerId,
            referenceType: body.orderReference ? `order-draft:${body.orderReference}` : 'payment_request',
            sentById: user.id,
        });
    }
    // ── Opt-out / opt-in ──────────────────────────────────────────────────────
    /** POST /api/notifications/opt-out — agent-triggered opt-out */
    optOut(body) {
        return this.notificationsService.optOut(body).then(() => ({ success: true }));
    }
    /** POST /api/notifications/opt-in — remove a contact from the opt-out list */
    optIn(body) {
        return this.notificationsService.optIn(body).then(() => ({ success: true }));
    }
};
exports.NotificationsController = NotificationsController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_READ),
    tslib_1.__param(0, (0, common_1.Query)('channel')),
    tslib_1.__param(1, (0, common_1.Query)('status')),
    tslib_1.__param(2, (0, common_1.Query)('template')),
    tslib_1.__param(3, (0, common_1.Query)('search')),
    tslib_1.__param(4, (0, common_1.Query)('page')),
    tslib_1.__param(5, (0, common_1.Query)('limit')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, String, String, String, String]),
    tslib_1.__metadata("design:returntype", void 0)
], NotificationsController.prototype, "getLogs", null);
tslib_1.__decorate([
    (0, common_1.Post)('test-send'),
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_READ),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_b = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], NotificationsController.prototype, "testSend", null);
tslib_1.__decorate([
    (0, common_1.Post)('payment-request'),
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_MARK_PAYMENT),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_c = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _c : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], NotificationsController.prototype, "sendPaymentRequest", null);
tslib_1.__decorate([
    (0, common_1.Post)('opt-out'),
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_READ),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], NotificationsController.prototype, "optOut", null);
tslib_1.__decorate([
    (0, common_1.Post)('opt-in'),
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_READ),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], NotificationsController.prototype, "optIn", null);
exports.NotificationsController = NotificationsController = tslib_1.__decorate([
    (0, common_1.Controller)('notifications'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof notifications_service_1.NotificationsService !== "undefined" && notifications_service_1.NotificationsService) === "function" ? _a : Object])
], NotificationsController);
